import React, {useState, useEffect} from 'react';
import { Helmet } from 'react-helmet';
import BannerSlider from '../../components/AdsSlider/BannerSlider_728x90';
import firebaseDb from './../../firebase';

const CloudminingPage = props => {
  var siteTitle = "Easy Crypto Coins | Best PTC Sites";
  var siteDescription = "Easy Crypto Site is a list of best websites where you can earn your favorite Crpto Coins.";
    
  var [currentId, setCurrentId] = useState('');  
    var [adsObjects, setAdsObjects] = useState({})


    // Fetch Data from Firebase
    useEffect(() => {  
        firebaseDb.child('cloudmining').on('value', snapshot => {  
            if (snapshot.val() != null) {
                console.log(snapshot)
                setAdsObjects({  
                    ...snapshot.val()  
                });  
            }  else{
                setAdsObjects({});
            }
        })  
    }, [])
        
          

    return (
        <>
        <Helmet>
            <meta name="description" content= {siteDescription} />
            <title>{siteTitle}</title>
        </Helmet>

            <div className="main column col"> 
                            <div className="banner mt-1">
                                <BannerSlider />
                            </div>  
                     <div className="container mt-5">
                                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-3 row-cols-xl-3">
                                {
                                      Object.keys(adsObjects).map((key) => (
                                        <div className="col mb-4 cards">
                                        <div className="card tfx-1">
                                        <div  className="card-img-top" style={{ backgroundImage:`url(${adsObjects[key].image})`}}></div>
      
                                                  <div className="card-body">
                                                  <h5 className="card-title display-4"><a className="card-details" href={`http://sh.st/st/4152f4bc9d1aca5236b3ab14a650a949/${adsObjects[key].link}`} target="_blank" rel="noreferrer"> {adsObjects[key].title}</a></h5>
                                                      <p className="card-text info">
                                                          <span>{adsObjects[key].info}</span>                                                    
                                                      </p>
                                                      <p className="card-text">
                                                          <span>Features:</span> {adsObjects[key].features}<br/>
                                                          <span>Type:</span> {adsObjects[key].type}<br/>
                                                          <span>Coins/Token:</span> {adsObjects[key].coins}<br/>
                                                          <span>Withdrawal:</span> {adsObjects[key].withdrawal }<br/>
                                                      </p>
      
                                                      <div className="button-container">
                                                          <a href={`http://sh.st/st/4152f4bc9d1aca5236b3ab14a650a949/${adsObjects[key].link}`} target="_blank" rel="noreferrer" >                     
                                                              <button type="button" className="btn btn-outline-success btn-block tfx-1">Go <i className="fa fa-arrow-right"></i> </button>
                                                          </a>
                                                      </div>
                                                  </div>
                                        </div>                                
                                      </div>
                                      ))
                                      }
                                    </div>
                    </div>
            </div>
        </>
    )
    
}

export default CloudminingPage;